import { render, staticRenderFns } from "./AreaSupportCreate.vue?vue&type=template&id=181e8f6a"
import script from "./AreaSupportCreate.vue?vue&type=script&lang=js"
export * from "./AreaSupportCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports